import { map } from "lodash";

export interface CibilRequest {
    userId: string;
    generatedUserId: string;
    name: string;
    gender: string;
    address: string;
    city: string;
    state: string;
    postal: string;
    phoneNumber: string;
    emailId: string;
    panNumber: string;
    owner: string;
    dob?: string;
}

export interface CibilResponse {
    id?: string,
    userId?: string,
    panNumber?: string,
    source?: string,
    score?: string,
    isNotDated?: true,
    owner?: string,
    createdAt?: string,
    createdBy?: string,
    fileUrl?: string,
    fileName?: string,
    responseStatus?: {
        status: ResponseStatus,
        statusCode?: ResponseStatusCode,
        statusMessage?: string
    }
    userInputs?: {
        USER_INPUT_TYPE?: string,
        AUTH_QUESTION_CONFIG_IDENTIFIER?: string,
        AUTH_ANSWER_IDENTIFIER?: string,
        AUTH_QUESTION_IDENTIFIER?: string,
        AUTH_ANSWER?: string
    }
}

export enum ResponseStatus {
    SUCCESS = 'SUCCESS',
    IN_PROGRESS = 'IN_PROGRESS',
    FAILURE = 'FAILURE'
}

export enum ResponseStatusCode {
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    USER_AUTHENTICATION_REQUIRED = 'USER_AUTHENTICATION_REQUIRED',
    INVALID_INPUT = 'INVALID_INPUT',
    EMAIL_VERIFICATION_CODE_REQUIRED = 'EMAIL_VERIFICATION_CODE_REQUIRED',
    MOBILE_VERIFICATION_CODE_REQUIRED = 'MOBILE_VERIFICATION_CODE_REQUIRED',
    ALTERNATE_MOBILE_NO_REQUIRED = 'ALTERNATE_MOBILE_NO_REQUIRED',
    REGENERATE_VERIFICATION_CODE_NOT_ALLOWED = 'REGENERATE_VERIFICATION_CODE_NOT_ALLOWED'
}

export enum UserInputTypes {
    VERIFICATION_CODE = "USER_INPUT_TYPE_VERIFICATION_CODE",
    ALTERNATIVE_NUMBER = "USER_INPUT_TYPE_ALTERNATE_MOBILE",
    USER_INPUT_REQUIRED = "USER_INPUT_REQUIRED",
    USER_INPUT_TYPE = "USER_INPUT_TYPE",
    AUTH_ANSWER = "AUTH_ANSWER",
    REGENERATE_VERIFICATION_CODE = "REGENERATE_VERIFICATION_CODE"
}

export const myMap = new Map([
    ["IN_PROGRESS", "USER_AUTHENTICATION_REQUIRED"],
    ["USER_AUTHENTICATION_REQUIRED", "two"],
    ["USER_AUTHENTICATION_REQUIRED", "three"],
]);


export enum CibilDefaultValues {
    GENDER = 'Male',
    ADDRESS = 'Default',
    CITY = 'Default',
    STATE = 'Maharashtra',
    POSTAL = '400001',
    OWNER = 'CUSTOMER'
}

export interface CibilRedirectionData {
    creditScore: string,
    creditReportId: string,
    pan: string,
    personalInfo?: {
        email: string,
        dob?: string
    },
    livelihoodInfo?: {
        employmentType: string,
        income: string | number
    },
    noHistory?: boolean
}